// extracted by mini-css-extract-plugin
export default {"sbtH6":"SbtH6_sbtH6__4hHU8"};